import classNames from 'classnames';

type Props = {
  onClick?: () => void;
};

export const ProviderHospitalIcon = ({ onClick }: Props) => {
  return (
    <svg
      className={classNames(onClick ? 'cursor-pointer' : '')}
      onClick={onClick ? onClick : undefined}
      width="15"
      height="20"
      viewBox="0 0 60 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.03 45.3049C0.03 45.3049 0 13.3299 0 12.4149C0 11.4099 0.525 11.2349 1.365 11.2099C2.17 11.1849 57.605 11.1599 58.48 11.1849C59.625 11.2149 59.73 11.9349 59.77 12.8499C59.81 13.7649 59.78 45.3299 59.78 45.3299L28.465 45.9099L0.03 45.3049Z"
        fill="#BACFD4"
      />
      <path
        d="M0.0299988 45.3049C0.0299988 45.3049 0.0449986 58.5749 0.0449986 59.2649C0.0449986 59.9549 0.544999 60.4549 1.49 60.4549C2.435 60.4549 57.785 60.3299 58.54 60.3299C59.295 60.3299 59.73 59.6399 59.795 58.5099C59.86 57.3799 59.79 45.3249 59.79 45.3249L0.0299988 45.3049Z"
        fill="#6BA4AE"
      />
      <path
        d="M14.765 49.48L14.82 60.415H44.48L44.53 49.27L14.765 49.48Z"
        fill="#546F7A"
      />
      <path d="M17.9 50.03V60.405H19.55V49.885L17.9 50.03Z" fill="#B9CED3" />
      <path
        d="M28.865 49.835V60.39H30.535V49.675L28.865 49.835Z"
        fill="#B9CED3"
      />
      <path
        d="M40.17 49.8549V60.4149H41.885V49.6299L40.17 49.8549Z"
        fill="#B9CED3"
      />
      <path
        d="M17.575 45.43C17.575 45.43 17.4 2.685 17.4 1.76C17.4 0.835 17.755 0.105 18.68 0.045C19.605 -0.015 39.56 -0.015 40.37 0.045C41.18 0.105 41.695 0.605 41.695 1.645C41.695 2.685 41.81 45.43 41.81 45.43L50.255 46.47V49.015C50.255 49.825 49.965 50.145 49.125 50.145H9.645C8.895 50.145 8.66 49.365 8.66 48.555V45.835L17.575 45.43Z"
        fill="#F1EDEC"
      />
      <path
        d="M8.67999 46.72L50.255 46.7C50.255 46.7 50.28 45.805 50.255 45.36C50.22 44.73 49.685 44.71 48.465 44.71H9.64999C9.11999 44.71 8.70999 44.895 8.66999 45.425C8.62999 45.955 8.67999 46.695 8.67999 46.72Z"
        fill="#FEFFFD"
      />
      <path
        d="M21.595 30.8999C21.71 31.0149 37.25 31.0849 37.35 30.9799C37.44 30.8849 37.51 25.1349 37.39 25.0149C37.235 24.8599 21.715 24.8949 21.595 25.0149C21.475 25.1349 21.475 30.7749 21.595 30.8999Z"
        fill="#546F7A"
      />
      <path
        d="M21.635 35.775C21.43 35.845 21.595 41.62 21.595 41.62L37.43 41.5C37.43 41.5 37.57 35.91 37.31 35.78C37.15 35.695 21.88 35.695 21.635 35.775Z"
        fill="#546F7A"
      />
      <path d="M43.88 15.1V21.47H49.885V15.02L43.88 15.1Z" fill="#546F7A" />
      <path
        d="M52.26 15.02H57.945L58.025 21.39H52.22L52.26 15.02Z"
        fill="#546F7A"
      />
      <path
        d="M52.18 25.175L52.14 31.34H57.905L57.985 25.175H52.18Z"
        fill="#546F7A"
      />
      <path
        d="M49.885 25.135H43.84V31.34H49.965L49.885 25.135Z"
        fill="#546F7A"
      />
      <path
        d="M49.925 35.3699H43.88V41.6949H50.005C50.005 41.6999 49.845 35.2899 49.925 35.3699Z"
        fill="#546F7A"
      />
      <path
        d="M52.18 35.33H57.9V41.78H52.18C52.18 41.78 52.24 35.27 52.18 35.33Z"
        fill="#546F7A"
      />
      <path
        d="M10.03 41.6149V35.2099L15.915 35.1299V41.5349L10.03 41.6149Z"
        fill="#546F7A"
      />
      <path
        d="M7.77499 41.5749V35.1699H1.76999L1.80999 41.6599C1.80999 41.6549 7.85499 41.5749 7.77499 41.5749Z"
        fill="#546F7A"
      />
      <path
        d="M1.73001 25.0149H7.81501V31.1799H1.73001V25.0149Z"
        fill="#546F7A"
      />
      <path
        d="M10.11 24.9751V31.1801H15.835V25.0151L10.11 24.9751Z"
        fill="#546F7A"
      />
      <path d="M10.19 14.78H15.75V21.27H10.19V14.78Z" fill="#546F7A" />
      <path d="M7.695 15.02L1.81 14.98V21.185H7.695V15.02Z" fill="#546F7A" />
      <path
        d="M26.32 8.58498C26.32 8.58498 26.31 2.40998 26.355 1.98998C26.395 1.56498 26.65 1.47998 26.95 1.47998C27.245 1.47998 32.375 1.47998 32.67 1.51998C32.965 1.55998 33.095 1.81498 33.095 2.28498V8.55498C33.095 8.55498 39.195 8.59498 39.45 8.59498C39.705 8.59498 39.96 8.88998 39.96 9.22998V14.82C39.96 15.2 39.92 15.585 39.45 15.665C38.98 15.745 33.055 15.665 33.055 15.665V22.71C33.055 23 32.81 23.25 32.4 23.28C31.99 23.31 26.905 23.28 26.62 23.28C26.335 23.28 26.335 22.425 26.335 22.135V15.815H19.695C19.405 15.815 19.28 15.53 19.25 14.99C19.22 14.45 19.27 9.55998 19.28 9.27498C19.3 8.82998 19.47 8.61498 19.785 8.58498C20.095 8.55998 26.32 8.58498 26.32 8.58498Z"
        fill="#DD0C26"
      />
      <path d="M28.915 3.97998H30.495V21.03H28.915V3.97998Z" fill="white" />
      <path d="M21.695 11.325H37.475V12.93H21.695V11.325Z" fill="white" />
    </svg>
  );
};
